export default __webpack_public_path__ + "static/media/O-088.bfa3556d.png";